import React, { useEffect, useState } from "react";

// Carousel Item Component for Events
function EventCarouselItem({ imgUrl, title }) {
  return (
    <div className="carousel-card">
      <div className="relative h-auto rounded-lg overflow-hidden shadow-md bg-white">
        <img src={imgUrl} alt={title} className="w-full h-96 object-cover" />
        {/* <div className="px-4 py-2">
          <h3 className="text-lg text-center font-semibold mb-1 truncate text-blue-800 group-hover:text-yellow-500 transition-colors">
            {title}
          </h3>
        </div> */}
      </div>
    </div>
  );
}

// Infinite Carousel for Events
function EventCarousel({ direction = 'left', events = [], language }) {
  const [cardsToShow, setCardsToShow] = useState(4); // Default number of cards to display at once
  const [animationDuration, setAnimationDuration] = useState('30s'); // Default duration

  useEffect(() => {
    document.documentElement.style.setProperty('--cards-to-show', cardsToShow);
    document.documentElement.style.setProperty('--items-count', events.length);
    document.documentElement.style.setProperty('--animation-duration', animationDuration);
  }, [cardsToShow, events.length, animationDuration]);
  
  useEffect(() => {
    const updateCarouselSettings = () => {
      const width = window.innerWidth;
      let cards = 4;
      
      if (width < 480) {
        cards = 1;
      } else if (width < 640) {
        cards = 2;
      } else if (width < 1024) {
        cards = 3;
      }
      
      setCardsToShow(cards);
      setAnimationDuration(`${Math.max(25, 30 / cards)}s`);
    };
  
    updateCarouselSettings(); // Run on mount
    window.addEventListener('resize', updateCarouselSettings);
    
    return () => {
      window.removeEventListener('resize', updateCarouselSettings);
    };
  }, []);

  return (
    <div className="carousel-container">
      <div className={`carousel-track ${direction === 'left' ? 'scroll-left' : 'scroll-right'}`}>
        {events.map((event) => (
          <EventCarouselItem 
            key={event.id} 
            imgUrl={event.image}
            title={language === 'en' ? event.title_EN : event.title_UR} 
          />
        ))}
        {/* Duplicate items for infinite scrolling effect */}
        {events.map((event) => (
          <EventCarouselItem 
            key={`duplicate-${event.id}`} 
            imgUrl={event.image} 
            title={language === 'en' ? event.title_EN : event.title_UR} 
          />
        ))}
      </div>
    </div>
  );
}

// Events Section Component
export function EventsSection({ events, language }) {
  return (
    <section className="py-6 md:py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-blue-800 mb-6 text-center">
          {language === 'en' ? "Recent Events" : "حالیہ واقعات"}
        </h2>
        <EventCarousel direction="left" events={events} language={language} />
      </div>
    </section>
  );
}

export default EventsSection;
